module.exports = __webpack_public_path__ + "static/sdk-header@3x-bac7eb3abd9c3fa0e4454aceb0257a18.gif";